<template>
  <div :class="componentClassName">
    <div class="o-sf-sidebar__logo">
      <a-brand-logo variant="horizontal" />
    </div>
    <div class="o-sf-sidebar__user-status">
      <a-button v-if="canMigrateFromTrial" id="invite" variant="round" color="green" @click="handleInviteLink()"
        >本申し込みはこちら</a-button
      >
    </div>
    <teleport to="body">
      <o-modal
        id="sfSidebar_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="confirmResult"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ABrandLogo from '@/components/atoms/brand-logo';
import MSfCurrentUserStatus from '@/components/molecules/sf-current-user-status';
import Simplebar from 'simplebar';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 'o-sf-sidebar',
  components: {
    ABrandLogo,
  },
  mixins: [customRequest],
  props: {
    variant: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|primary)/);
      },
    },
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    currentUserInfo: {
      type: Object,
      default: null,
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    currentActiveItemId: {
      type: String,
      default: '',
    },
    handleOnlineStatusChange: {
      type: Function,
      default: () => {},
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
    username: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isAuthenticated: false,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-sf-sidebar', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
    canMigrateFromTrial() {
      const companyID = this.currentUserInfo.company_id;
      const authInfo = this.currentUserInfo.auth_info;
      return /^tri\d{6}$/.exec(companyID) && authInfo === 'supervisor' ? true : false;
    },
  },
  created() {
    this.isAuthenticated = this.$route.params.isAuthenticated;
  },
  mounted() {},
  methods: {
    isNavActive(navItem) {
      let active = false;
      if (navItem.nav_id === this.currentActiveItemId) {
        active = true;
      } else {
        // check child active
        active = this.isSubNavActive(navItem);
      }
      return active;
    },
    isSubNavActive(navItem) {
      let active = false;
      if (navItem.items) {
        navItem.items.forEach(subNavItem => {
          if (subNavItem.nav_id === this.currentActiveItemId) {
            active = true;
          }
        });
      }
      return active;
    },
    handleClick: function (route_name) {
      if (!route_name || route_name === this.$route.name) return;
      if (this.isAuthenticated) {
        this.isAuthenticated = false;
        this.$router.push({ name: route_name, params: { isAuthenticated: false, test: 123 } });
      } else {
        console.warn('The menu is temporarily disabled due to waiting for authentication!');
      }
    },
    handleInviteLink: function () {
      // トライアル移行情報取得
      this.postRequest('/contract/getcontractdata', { companyID: this.currentUserInfo.company_id })
        .then(e => {
          if (typeof e.data.contractedCompanyID !== 'undefined' && e.data.contractedCompanyID !== '') {
            this.showErrorModal(messageContent.trialCompanyIsContracted);
          } else {
            // 申し込み画面を別タブで開く
            const resolvedRoute = this.$router.resolve({ name: 'Signup' });
            const invitationWindow = window.open(resolvedRoute.href, '_blank');
            // 申し込み画面のロード(created)が完了し次第、messageイベント通知でトライアル移行フラグを送信
            invitationWindow.onload = () => {
              invitationWindow.postMessage('trialMigration', invitationWindow.origin);
            };
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
